<template>
	<div>
		<base-dialog v-model="disclaimerModalVisible" :dontShowAgainCookie="SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE" :dontShowAgainCookieExpirationDays="30">
			<p>
				{{ $t('microhabits.simple.panel-menu.on-block-click-disclaimer') }}
			</p>
		</base-dialog>
		<MicrohabitsPanelMenu :type="MICROHABIT_SIMPLE_TYPE" @blockClick="onBlockClick"/>
	</div>
</template>

<script>
import MicrohabitsPanelMenu from '@/components/microhabits/MicrohabitsPanelMenu'
import { MICROHABIT_SIMPLE_TYPE } from '@/constants/microhabitTypes'
import { SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE } from '@/constants/cookies'
import BaseDialog from '@/components/base/BaseDialog'

export default {
	components: {
		MicrohabitsPanelMenu,
		BaseDialog
	},
	data () {
		return {
			SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE,
			MICROHABIT_SIMPLE_TYPE,
			disclaimerModalVisible: false
		}
	},
	methods: {
		onBlockClick ({ category, microhabit }) {
			if (!this.$store.getters['session/userHasCompanies']) {
				this.$store.dispatch('showOnlySubscriptorsDialog')
				return
			}
			this.disclaimerModalVisible = true
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/webapp/patient/microhabits/SimpleMicrohabitsPanelMenu.vue